module.exports = __webpack_public_path__ + "img/old_air_mail.ca7af5e6.png";